export const GET_LIST = 'MEDICAL/get/list';
export const GOT_LIST = 'MEDICAL/got/list';
